<ng-container *ngIf="!isProductsDataLoading; else advancedCarouselSkeleton">
  <div appIsVisible (isVisible)="initializeAdvancedCarouselView()">
    <ng-container *ngTemplateOutlet="type === ADVANCED_TYPE_OPTIONS.titleWithCarousel ? titleCarousel : type === ADVANCED_TYPE_OPTIONS.bannerWithCarousel ? bannerCarousel : textboxCarousel"></ng-container>
  </div>
  <ng-template #titleCarousel>
    <app-advanced-title-carousel
      [title]="title || (getTitle() | translate)"
      [isPromo]="isPromoCarousel"
      [colorClass]="COLOR_CLASSES[color]"
      [products]="storyBlokProducts"
      [pageType]="pageTypeName"
      [isMobile]="isMobile"
      [isTablet]="isTablet"
      [isDesktop]="isDesktop"
      [isLandScapeTablet]="isLandScapeTablet"
      [trackingName]="trackingName"
      (onProductClick)="onProductClickEvent($event)"
      (onNavigate)="onProductCarouselNavigation($event)"
      (onSwipe)="onProductCarouselSwipe($event)"
    ></app-advanced-title-carousel>
  </ng-template>
  <ng-template #textboxCarousel>
    <app-advanced-textbox-carousel
      [title]="title || (getTitle() | translate)"
      [isPromo]="isPromoCarousel"
      [colorClass]="COLOR_CLASSES[color] || COLOR_CLASSES.white"
      [trackingName]="trackingName"
      [subHeading]="subHeading"
      [description]="description"
      [button]="button"
      [products]="storyBlokProducts"
      [isMobile]="isMobile"
      [isTablet]="isTablet"
      [isDesktop]="isDesktop"
      [isLandScapeTablet]="isLandScapeTablet"
      (onProductClick)="onProductClickEvent($event)"
      (onButtonClick)="navigateTo(); onButtonClickEvent()"
      (onNavigate)="onProductCarouselNavigation($event)"
      (onSwipe)="onProductCarouselSwipe($event)"
    ></app-advanced-textbox-carousel>
  </ng-template>
  <ng-template #bannerCarousel>
    <app-advanced-banner-carousel
      [title]="title || (getTitle() | translate)"
      [isPromo]="isPromoCarousel"
      [colorClass]="COLOR_CLASSES[color] || COLOR_CLASSES.white"
      [trackingName]="trackingName"
      [subHeading]="subHeading"
      [description]="description"
      [button]="button"
      [products]="storyBlokProducts"
      [image]="image"
      [isMobile]="isMobile"
      [isTablet]="isTablet"
      [isDesktop]="isDesktop"
      [isLandScapeTablet]="isLandScapeTablet"
      (onProductClick)="onProductClickEvent($event)"
      (onButtonClick)="navigateTo(); onButtonClickEvent()"
      (onNavigate)="onProductCarouselNavigation($event)"
      (onSwipe)="onProductCarouselSwipe($event)"
    ></app-advanced-banner-carousel>
  </ng-template>
</ng-container>

<ng-template #advancedCarouselSkeleton>
  <app-advanced-carousel-skeleton
    [isMobile]="isMobile"
    [isTablet]="isTablet"
    [isDesktop]="isDesktop"
    [isLandScapeTablet]="isLandScapeTablet"
  ></app-advanced-carousel-skeleton>
</ng-template>
